import { API } from '../types'

import { ShipstationAPI } from './shipstation'

export class IntegrationAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  get shipstation() {
    const api = new ShipstationAPI(this.api)
    Object.defineProperty(this, 'shipstation', { value: api })
    return api
  }
}
